
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as aboutu8Sb32ihwPMeta } from "/app/pages/about.vue?macro=true";
import { default as amrabRyxBFiLBxMeta } from "/app/pages/amra.vue?macro=true";
import { default as budgetingH6ZkukzRWbMeta } from "/app/pages/budgeting.vue?macro=true";
import { default as businessl9xJeDqVoeMeta } from "/app/pages/business.vue?macro=true";
import { default as cardsPWuoOV9bp7Meta } from "/app/pages/cards.vue?macro=true";
import { default as cart9SktLKPpbzMeta } from "/app/pages/cart.vue?macro=true";
import { default as _91id_93xRGFwWfgMhMeta } from "/app/pages/coins/[id].vue?macro=true";
import { default as indexta6b91hQU9Meta } from "/app/pages/coins/index.vue?macro=true";
import { default as depositsCddPR7XUIVMeta } from "/app/pages/deposits.vue?macro=true";
import { default as docscartIzQr0XZr4kMeta } from "/app/pages/docscart.vue?macro=true";
import { default as docsposterminalPY7sWBm97IMeta } from "/app/pages/docsposterminal.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as apinUOvaXNqlUMeta } from "/app/pages/locations/api.js?macro=true";
import { default as filtersAhuCf7ppvOMeta } from "/app/pages/locations/components/filters.vue?macro=true";
import { default as mapXCapa0VLgkMeta } from "/app/pages/locations/components/map.vue?macro=true";
import { default as old_45logic4V201sciHUMeta } from "/app/pages/locations/components/old-logic.js?macro=true";
import { default as search_45fieldPn3RaLpfCJMeta } from "/app/pages/locations/components/search-field.vue?macro=true";
import { default as indexILfcf96YXkMeta } from "/app/pages/locations/index.vue?macro=true";
import { default as _91id_93FIXkK569FdMeta } from "/app/pages/news/[id].vue?macro=true";
import { default as indexoxV4GRc61hMeta } from "/app/pages/news/index.vue?macro=true";
import { default as officesXrLYfoigSgMeta } from "/app/pages/offices.vue?macro=true";
import { default as indexcbTlewsiNxMeta } from "/app/pages/pay-online-24/[id]/index.vue?macro=true";
import { default as redirectNyeSKvOjiWMeta } from "/app/pages/pay-online-24/[id]/redirect.vue?macro=true";
import { default as indexTvYKXmOOQhMeta } from "/app/pages/pay-online-24/index.vue?macro=true";
import { default as _91id_93VVAEZJEHZ4Meta } from "/app/pages/payments/[id].vue?macro=true";
import { default as errorpgmqcJam7fMeta } from "/app/pages/payments/error.vue?macro=true";
import { default as index4DIviTw3fSMeta } from "/app/pages/payments/index.vue?macro=true";
import { default as successZawJoPYqJUMeta } from "/app/pages/payments/success.vue?macro=true";
import { default as posterminalCYSrR2OZPnMeta } from "/app/pages/posterminal.vue?macro=true";
import { default as safeboxesr6ECYcghNCMeta } from "/app/pages/safeboxes.vue?macro=true";
import { default as vacanciesAfH1oWmZlHMeta } from "/app/pages/vacancies.vue?macro=true";
export default [
  {
    name: "about___ru___default",
    path: "/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___ru",
    path: "/ru/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___es",
    path: "/es/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___ab",
    path: "/ab/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___tr",
    path: "/tr/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___ar",
    path: "/ar/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "amra___ru___default",
    path: "/amra",
    component: () => import("/app/pages/amra.vue")
  },
  {
    name: "amra___ru",
    path: "/ru/amra",
    component: () => import("/app/pages/amra.vue")
  },
  {
    name: "amra___en",
    path: "/en/amra",
    component: () => import("/app/pages/amra.vue")
  },
  {
    name: "amra___es",
    path: "/es/amra",
    component: () => import("/app/pages/amra.vue")
  },
  {
    name: "amra___ab",
    path: "/ab/amra",
    component: () => import("/app/pages/amra.vue")
  },
  {
    name: "amra___tr",
    path: "/tr/amra",
    component: () => import("/app/pages/amra.vue")
  },
  {
    name: "amra___ar",
    path: "/ar/amra",
    component: () => import("/app/pages/amra.vue")
  },
  {
    name: "budgeting___ru___default",
    path: "/budgeting",
    component: () => import("/app/pages/budgeting.vue")
  },
  {
    name: "budgeting___ru",
    path: "/ru/budgeting",
    component: () => import("/app/pages/budgeting.vue")
  },
  {
    name: "budgeting___en",
    path: "/en/budgeting",
    component: () => import("/app/pages/budgeting.vue")
  },
  {
    name: "budgeting___es",
    path: "/es/budgeting",
    component: () => import("/app/pages/budgeting.vue")
  },
  {
    name: "budgeting___ab",
    path: "/ab/budgeting",
    component: () => import("/app/pages/budgeting.vue")
  },
  {
    name: "budgeting___tr",
    path: "/tr/budgeting",
    component: () => import("/app/pages/budgeting.vue")
  },
  {
    name: "budgeting___ar",
    path: "/ar/budgeting",
    component: () => import("/app/pages/budgeting.vue")
  },
  {
    name: "business___ru___default",
    path: "/business",
    component: () => import("/app/pages/business.vue")
  },
  {
    name: "business___ru",
    path: "/ru/business",
    component: () => import("/app/pages/business.vue")
  },
  {
    name: "business___en",
    path: "/en/business",
    component: () => import("/app/pages/business.vue")
  },
  {
    name: "business___es",
    path: "/es/business",
    component: () => import("/app/pages/business.vue")
  },
  {
    name: "business___ab",
    path: "/ab/business",
    component: () => import("/app/pages/business.vue")
  },
  {
    name: "business___tr",
    path: "/tr/business",
    component: () => import("/app/pages/business.vue")
  },
  {
    name: "business___ar",
    path: "/ar/business",
    component: () => import("/app/pages/business.vue")
  },
  {
    name: "cards___ru___default",
    path: "/cards",
    component: () => import("/app/pages/cards.vue")
  },
  {
    name: "cards___ru",
    path: "/ru/cards",
    component: () => import("/app/pages/cards.vue")
  },
  {
    name: "cards___en",
    path: "/en/cards",
    component: () => import("/app/pages/cards.vue")
  },
  {
    name: "cards___es",
    path: "/es/cards",
    component: () => import("/app/pages/cards.vue")
  },
  {
    name: "cards___ab",
    path: "/ab/cards",
    component: () => import("/app/pages/cards.vue")
  },
  {
    name: "cards___tr",
    path: "/tr/cards",
    component: () => import("/app/pages/cards.vue")
  },
  {
    name: "cards___ar",
    path: "/ar/cards",
    component: () => import("/app/pages/cards.vue")
  },
  {
    name: "cart___ru___default",
    path: "/cart",
    component: () => import("/app/pages/cart.vue")
  },
  {
    name: "cart___ru",
    path: "/ru/cart",
    component: () => import("/app/pages/cart.vue")
  },
  {
    name: "cart___en",
    path: "/en/cart",
    component: () => import("/app/pages/cart.vue")
  },
  {
    name: "cart___es",
    path: "/es/cart",
    component: () => import("/app/pages/cart.vue")
  },
  {
    name: "cart___ab",
    path: "/ab/cart",
    component: () => import("/app/pages/cart.vue")
  },
  {
    name: "cart___tr",
    path: "/tr/cart",
    component: () => import("/app/pages/cart.vue")
  },
  {
    name: "cart___ar",
    path: "/ar/cart",
    component: () => import("/app/pages/cart.vue")
  },
  {
    name: "coins-id___ru___default",
    path: "/coins/:id()",
    component: () => import("/app/pages/coins/[id].vue")
  },
  {
    name: "coins-id___ru",
    path: "/ru/coins/:id()",
    component: () => import("/app/pages/coins/[id].vue")
  },
  {
    name: "coins-id___en",
    path: "/en/coins/:id()",
    component: () => import("/app/pages/coins/[id].vue")
  },
  {
    name: "coins-id___es",
    path: "/es/coins/:id()",
    component: () => import("/app/pages/coins/[id].vue")
  },
  {
    name: "coins-id___ab",
    path: "/ab/coins/:id()",
    component: () => import("/app/pages/coins/[id].vue")
  },
  {
    name: "coins-id___tr",
    path: "/tr/coins/:id()",
    component: () => import("/app/pages/coins/[id].vue")
  },
  {
    name: "coins-id___ar",
    path: "/ar/coins/:id()",
    component: () => import("/app/pages/coins/[id].vue")
  },
  {
    name: "coins___ru___default",
    path: "/coins",
    component: () => import("/app/pages/coins/index.vue")
  },
  {
    name: "coins___ru",
    path: "/ru/coins",
    component: () => import("/app/pages/coins/index.vue")
  },
  {
    name: "coins___en",
    path: "/en/coins",
    component: () => import("/app/pages/coins/index.vue")
  },
  {
    name: "coins___es",
    path: "/es/coins",
    component: () => import("/app/pages/coins/index.vue")
  },
  {
    name: "coins___ab",
    path: "/ab/coins",
    component: () => import("/app/pages/coins/index.vue")
  },
  {
    name: "coins___tr",
    path: "/tr/coins",
    component: () => import("/app/pages/coins/index.vue")
  },
  {
    name: "coins___ar",
    path: "/ar/coins",
    component: () => import("/app/pages/coins/index.vue")
  },
  {
    name: "deposits___ru___default",
    path: "/deposits",
    component: () => import("/app/pages/deposits.vue")
  },
  {
    name: "deposits___ru",
    path: "/ru/deposits",
    component: () => import("/app/pages/deposits.vue")
  },
  {
    name: "deposits___en",
    path: "/en/deposits",
    component: () => import("/app/pages/deposits.vue")
  },
  {
    name: "deposits___es",
    path: "/es/deposits",
    component: () => import("/app/pages/deposits.vue")
  },
  {
    name: "deposits___ab",
    path: "/ab/deposits",
    component: () => import("/app/pages/deposits.vue")
  },
  {
    name: "deposits___tr",
    path: "/tr/deposits",
    component: () => import("/app/pages/deposits.vue")
  },
  {
    name: "deposits___ar",
    path: "/ar/deposits",
    component: () => import("/app/pages/deposits.vue")
  },
  {
    name: "docscart___ru___default",
    path: "/docscart",
    component: () => import("/app/pages/docscart.vue")
  },
  {
    name: "docscart___ru",
    path: "/ru/docscart",
    component: () => import("/app/pages/docscart.vue")
  },
  {
    name: "docscart___en",
    path: "/en/docscart",
    component: () => import("/app/pages/docscart.vue")
  },
  {
    name: "docscart___es",
    path: "/es/docscart",
    component: () => import("/app/pages/docscart.vue")
  },
  {
    name: "docscart___ab",
    path: "/ab/docscart",
    component: () => import("/app/pages/docscart.vue")
  },
  {
    name: "docscart___tr",
    path: "/tr/docscart",
    component: () => import("/app/pages/docscart.vue")
  },
  {
    name: "docscart___ar",
    path: "/ar/docscart",
    component: () => import("/app/pages/docscart.vue")
  },
  {
    name: "docsposterminal___ru___default",
    path: "/docsposterminal",
    component: () => import("/app/pages/docsposterminal.vue")
  },
  {
    name: "docsposterminal___ru",
    path: "/ru/docsposterminal",
    component: () => import("/app/pages/docsposterminal.vue")
  },
  {
    name: "docsposterminal___en",
    path: "/en/docsposterminal",
    component: () => import("/app/pages/docsposterminal.vue")
  },
  {
    name: "docsposterminal___es",
    path: "/es/docsposterminal",
    component: () => import("/app/pages/docsposterminal.vue")
  },
  {
    name: "docsposterminal___ab",
    path: "/ab/docsposterminal",
    component: () => import("/app/pages/docsposterminal.vue")
  },
  {
    name: "docsposterminal___tr",
    path: "/tr/docsposterminal",
    component: () => import("/app/pages/docsposterminal.vue")
  },
  {
    name: "docsposterminal___ar",
    path: "/ar/docsposterminal",
    component: () => import("/app/pages/docsposterminal.vue")
  },
  {
    name: "index___ru___default",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___ab",
    path: "/ab",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___tr",
    path: "/tr",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___ar",
    path: "/ar",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "locations-api___ru___default",
    path: "/locations/api",
    component: () => import("/app/pages/locations/api.js")
  },
  {
    name: "locations-api___ru",
    path: "/ru/locations/api",
    component: () => import("/app/pages/locations/api.js")
  },
  {
    name: "locations-api___en",
    path: "/en/locations/api",
    component: () => import("/app/pages/locations/api.js")
  },
  {
    name: "locations-api___es",
    path: "/es/locations/api",
    component: () => import("/app/pages/locations/api.js")
  },
  {
    name: "locations-api___ab",
    path: "/ab/locations/api",
    component: () => import("/app/pages/locations/api.js")
  },
  {
    name: "locations-api___tr",
    path: "/tr/locations/api",
    component: () => import("/app/pages/locations/api.js")
  },
  {
    name: "locations-api___ar",
    path: "/ar/locations/api",
    component: () => import("/app/pages/locations/api.js")
  },
  {
    name: "locations-components-filters___ru___default",
    path: "/locations/components/filters",
    component: () => import("/app/pages/locations/components/filters.vue")
  },
  {
    name: "locations-components-filters___ru",
    path: "/ru/locations/components/filters",
    component: () => import("/app/pages/locations/components/filters.vue")
  },
  {
    name: "locations-components-filters___en",
    path: "/en/locations/components/filters",
    component: () => import("/app/pages/locations/components/filters.vue")
  },
  {
    name: "locations-components-filters___es",
    path: "/es/locations/components/filters",
    component: () => import("/app/pages/locations/components/filters.vue")
  },
  {
    name: "locations-components-filters___ab",
    path: "/ab/locations/components/filters",
    component: () => import("/app/pages/locations/components/filters.vue")
  },
  {
    name: "locations-components-filters___tr",
    path: "/tr/locations/components/filters",
    component: () => import("/app/pages/locations/components/filters.vue")
  },
  {
    name: "locations-components-filters___ar",
    path: "/ar/locations/components/filters",
    component: () => import("/app/pages/locations/components/filters.vue")
  },
  {
    name: "locations-components-map___ru___default",
    path: "/locations/components/map",
    component: () => import("/app/pages/locations/components/map.vue")
  },
  {
    name: "locations-components-map___ru",
    path: "/ru/locations/components/map",
    component: () => import("/app/pages/locations/components/map.vue")
  },
  {
    name: "locations-components-map___en",
    path: "/en/locations/components/map",
    component: () => import("/app/pages/locations/components/map.vue")
  },
  {
    name: "locations-components-map___es",
    path: "/es/locations/components/map",
    component: () => import("/app/pages/locations/components/map.vue")
  },
  {
    name: "locations-components-map___ab",
    path: "/ab/locations/components/map",
    component: () => import("/app/pages/locations/components/map.vue")
  },
  {
    name: "locations-components-map___tr",
    path: "/tr/locations/components/map",
    component: () => import("/app/pages/locations/components/map.vue")
  },
  {
    name: "locations-components-map___ar",
    path: "/ar/locations/components/map",
    component: () => import("/app/pages/locations/components/map.vue")
  },
  {
    name: "locations-components-old-logic___ru___default",
    path: "/locations/components/old-logic",
    component: () => import("/app/pages/locations/components/old-logic.js")
  },
  {
    name: "locations-components-old-logic___ru",
    path: "/ru/locations/components/old-logic",
    component: () => import("/app/pages/locations/components/old-logic.js")
  },
  {
    name: "locations-components-old-logic___en",
    path: "/en/locations/components/old-logic",
    component: () => import("/app/pages/locations/components/old-logic.js")
  },
  {
    name: "locations-components-old-logic___es",
    path: "/es/locations/components/old-logic",
    component: () => import("/app/pages/locations/components/old-logic.js")
  },
  {
    name: "locations-components-old-logic___ab",
    path: "/ab/locations/components/old-logic",
    component: () => import("/app/pages/locations/components/old-logic.js")
  },
  {
    name: "locations-components-old-logic___tr",
    path: "/tr/locations/components/old-logic",
    component: () => import("/app/pages/locations/components/old-logic.js")
  },
  {
    name: "locations-components-old-logic___ar",
    path: "/ar/locations/components/old-logic",
    component: () => import("/app/pages/locations/components/old-logic.js")
  },
  {
    name: "locations-components-search-field___ru___default",
    path: "/locations/components/search-field",
    component: () => import("/app/pages/locations/components/search-field.vue")
  },
  {
    name: "locations-components-search-field___ru",
    path: "/ru/locations/components/search-field",
    component: () => import("/app/pages/locations/components/search-field.vue")
  },
  {
    name: "locations-components-search-field___en",
    path: "/en/locations/components/search-field",
    component: () => import("/app/pages/locations/components/search-field.vue")
  },
  {
    name: "locations-components-search-field___es",
    path: "/es/locations/components/search-field",
    component: () => import("/app/pages/locations/components/search-field.vue")
  },
  {
    name: "locations-components-search-field___ab",
    path: "/ab/locations/components/search-field",
    component: () => import("/app/pages/locations/components/search-field.vue")
  },
  {
    name: "locations-components-search-field___tr",
    path: "/tr/locations/components/search-field",
    component: () => import("/app/pages/locations/components/search-field.vue")
  },
  {
    name: "locations-components-search-field___ar",
    path: "/ar/locations/components/search-field",
    component: () => import("/app/pages/locations/components/search-field.vue")
  },
  {
    name: "locations___ru___default",
    path: "/locations",
    component: () => import("/app/pages/locations/index.vue")
  },
  {
    name: "locations___ru",
    path: "/ru/locations",
    component: () => import("/app/pages/locations/index.vue")
  },
  {
    name: "locations___en",
    path: "/en/locations",
    component: () => import("/app/pages/locations/index.vue")
  },
  {
    name: "locations___es",
    path: "/es/locations",
    component: () => import("/app/pages/locations/index.vue")
  },
  {
    name: "locations___ab",
    path: "/ab/locations",
    component: () => import("/app/pages/locations/index.vue")
  },
  {
    name: "locations___tr",
    path: "/tr/locations",
    component: () => import("/app/pages/locations/index.vue")
  },
  {
    name: "locations___ar",
    path: "/ar/locations",
    component: () => import("/app/pages/locations/index.vue")
  },
  {
    name: "news-id___ru___default",
    path: "/news/:id()",
    component: () => import("/app/pages/news/[id].vue")
  },
  {
    name: "news-id___ru",
    path: "/ru/news/:id()",
    component: () => import("/app/pages/news/[id].vue")
  },
  {
    name: "news-id___en",
    path: "/en/news/:id()",
    component: () => import("/app/pages/news/[id].vue")
  },
  {
    name: "news-id___es",
    path: "/es/news/:id()",
    component: () => import("/app/pages/news/[id].vue")
  },
  {
    name: "news-id___ab",
    path: "/ab/news/:id()",
    component: () => import("/app/pages/news/[id].vue")
  },
  {
    name: "news-id___tr",
    path: "/tr/news/:id()",
    component: () => import("/app/pages/news/[id].vue")
  },
  {
    name: "news-id___ar",
    path: "/ar/news/:id()",
    component: () => import("/app/pages/news/[id].vue")
  },
  {
    name: "news___ru___default",
    path: "/news",
    component: () => import("/app/pages/news/index.vue")
  },
  {
    name: "news___ru",
    path: "/ru/news",
    component: () => import("/app/pages/news/index.vue")
  },
  {
    name: "news___en",
    path: "/en/news",
    component: () => import("/app/pages/news/index.vue")
  },
  {
    name: "news___es",
    path: "/es/news",
    component: () => import("/app/pages/news/index.vue")
  },
  {
    name: "news___ab",
    path: "/ab/news",
    component: () => import("/app/pages/news/index.vue")
  },
  {
    name: "news___tr",
    path: "/tr/news",
    component: () => import("/app/pages/news/index.vue")
  },
  {
    name: "news___ar",
    path: "/ar/news",
    component: () => import("/app/pages/news/index.vue")
  },
  {
    name: "offices___ru___default",
    path: "/offices",
    component: () => import("/app/pages/offices.vue")
  },
  {
    name: "offices___ru",
    path: "/ru/offices",
    component: () => import("/app/pages/offices.vue")
  },
  {
    name: "offices___en",
    path: "/en/offices",
    component: () => import("/app/pages/offices.vue")
  },
  {
    name: "offices___es",
    path: "/es/offices",
    component: () => import("/app/pages/offices.vue")
  },
  {
    name: "offices___ab",
    path: "/ab/offices",
    component: () => import("/app/pages/offices.vue")
  },
  {
    name: "offices___tr",
    path: "/tr/offices",
    component: () => import("/app/pages/offices.vue")
  },
  {
    name: "offices___ar",
    path: "/ar/offices",
    component: () => import("/app/pages/offices.vue")
  },
  {
    name: "pay-online-24-id___ru___default",
    path: "/pay-online-24/:id()",
    component: () => import("/app/pages/pay-online-24/[id]/index.vue")
  },
  {
    name: "pay-online-24-id___ru",
    path: "/ru/pay-online-24/:id()",
    component: () => import("/app/pages/pay-online-24/[id]/index.vue")
  },
  {
    name: "pay-online-24-id___en",
    path: "/en/pay-online-24/:id()",
    component: () => import("/app/pages/pay-online-24/[id]/index.vue")
  },
  {
    name: "pay-online-24-id___es",
    path: "/es/pay-online-24/:id()",
    component: () => import("/app/pages/pay-online-24/[id]/index.vue")
  },
  {
    name: "pay-online-24-id___ab",
    path: "/ab/pay-online-24/:id()",
    component: () => import("/app/pages/pay-online-24/[id]/index.vue")
  },
  {
    name: "pay-online-24-id___tr",
    path: "/tr/pay-online-24/:id()",
    component: () => import("/app/pages/pay-online-24/[id]/index.vue")
  },
  {
    name: "pay-online-24-id___ar",
    path: "/ar/pay-online-24/:id()",
    component: () => import("/app/pages/pay-online-24/[id]/index.vue")
  },
  {
    name: "pay-online-24-id-redirect___ru___default",
    path: "/pay-online-24/:id()/redirect",
    component: () => import("/app/pages/pay-online-24/[id]/redirect.vue")
  },
  {
    name: "pay-online-24-id-redirect___ru",
    path: "/ru/pay-online-24/:id()/redirect",
    component: () => import("/app/pages/pay-online-24/[id]/redirect.vue")
  },
  {
    name: "pay-online-24-id-redirect___en",
    path: "/en/pay-online-24/:id()/redirect",
    component: () => import("/app/pages/pay-online-24/[id]/redirect.vue")
  },
  {
    name: "pay-online-24-id-redirect___es",
    path: "/es/pay-online-24/:id()/redirect",
    component: () => import("/app/pages/pay-online-24/[id]/redirect.vue")
  },
  {
    name: "pay-online-24-id-redirect___ab",
    path: "/ab/pay-online-24/:id()/redirect",
    component: () => import("/app/pages/pay-online-24/[id]/redirect.vue")
  },
  {
    name: "pay-online-24-id-redirect___tr",
    path: "/tr/pay-online-24/:id()/redirect",
    component: () => import("/app/pages/pay-online-24/[id]/redirect.vue")
  },
  {
    name: "pay-online-24-id-redirect___ar",
    path: "/ar/pay-online-24/:id()/redirect",
    component: () => import("/app/pages/pay-online-24/[id]/redirect.vue")
  },
  {
    name: "pay-online-24___ru___default",
    path: "/pay-online-24",
    component: () => import("/app/pages/pay-online-24/index.vue")
  },
  {
    name: "pay-online-24___ru",
    path: "/ru/pay-online-24",
    component: () => import("/app/pages/pay-online-24/index.vue")
  },
  {
    name: "pay-online-24___en",
    path: "/en/pay-online-24",
    component: () => import("/app/pages/pay-online-24/index.vue")
  },
  {
    name: "pay-online-24___es",
    path: "/es/pay-online-24",
    component: () => import("/app/pages/pay-online-24/index.vue")
  },
  {
    name: "pay-online-24___ab",
    path: "/ab/pay-online-24",
    component: () => import("/app/pages/pay-online-24/index.vue")
  },
  {
    name: "pay-online-24___tr",
    path: "/tr/pay-online-24",
    component: () => import("/app/pages/pay-online-24/index.vue")
  },
  {
    name: "pay-online-24___ar",
    path: "/ar/pay-online-24",
    component: () => import("/app/pages/pay-online-24/index.vue")
  },
  {
    name: "payments-id___ru___default",
    path: "/payments/:id()",
    component: () => import("/app/pages/payments/[id].vue")
  },
  {
    name: "payments-id___ru",
    path: "/ru/payments/:id()",
    component: () => import("/app/pages/payments/[id].vue")
  },
  {
    name: "payments-id___en",
    path: "/en/payments/:id()",
    component: () => import("/app/pages/payments/[id].vue")
  },
  {
    name: "payments-id___es",
    path: "/es/payments/:id()",
    component: () => import("/app/pages/payments/[id].vue")
  },
  {
    name: "payments-id___ab",
    path: "/ab/payments/:id()",
    component: () => import("/app/pages/payments/[id].vue")
  },
  {
    name: "payments-id___tr",
    path: "/tr/payments/:id()",
    component: () => import("/app/pages/payments/[id].vue")
  },
  {
    name: "payments-id___ar",
    path: "/ar/payments/:id()",
    component: () => import("/app/pages/payments/[id].vue")
  },
  {
    name: "payments-error___ru___default",
    path: "/payments/error",
    component: () => import("/app/pages/payments/error.vue")
  },
  {
    name: "payments-error___ru",
    path: "/ru/payments/error",
    component: () => import("/app/pages/payments/error.vue")
  },
  {
    name: "payments-error___en",
    path: "/en/payments/error",
    component: () => import("/app/pages/payments/error.vue")
  },
  {
    name: "payments-error___es",
    path: "/es/payments/error",
    component: () => import("/app/pages/payments/error.vue")
  },
  {
    name: "payments-error___ab",
    path: "/ab/payments/error",
    component: () => import("/app/pages/payments/error.vue")
  },
  {
    name: "payments-error___tr",
    path: "/tr/payments/error",
    component: () => import("/app/pages/payments/error.vue")
  },
  {
    name: "payments-error___ar",
    path: "/ar/payments/error",
    component: () => import("/app/pages/payments/error.vue")
  },
  {
    name: "payments___ru___default",
    path: "/payments",
    component: () => import("/app/pages/payments/index.vue")
  },
  {
    name: "payments___ru",
    path: "/ru/payments",
    component: () => import("/app/pages/payments/index.vue")
  },
  {
    name: "payments___en",
    path: "/en/payments",
    component: () => import("/app/pages/payments/index.vue")
  },
  {
    name: "payments___es",
    path: "/es/payments",
    component: () => import("/app/pages/payments/index.vue")
  },
  {
    name: "payments___ab",
    path: "/ab/payments",
    component: () => import("/app/pages/payments/index.vue")
  },
  {
    name: "payments___tr",
    path: "/tr/payments",
    component: () => import("/app/pages/payments/index.vue")
  },
  {
    name: "payments___ar",
    path: "/ar/payments",
    component: () => import("/app/pages/payments/index.vue")
  },
  {
    name: "payments-success___ru___default",
    path: "/payments/success",
    component: () => import("/app/pages/payments/success.vue")
  },
  {
    name: "payments-success___ru",
    path: "/ru/payments/success",
    component: () => import("/app/pages/payments/success.vue")
  },
  {
    name: "payments-success___en",
    path: "/en/payments/success",
    component: () => import("/app/pages/payments/success.vue")
  },
  {
    name: "payments-success___es",
    path: "/es/payments/success",
    component: () => import("/app/pages/payments/success.vue")
  },
  {
    name: "payments-success___ab",
    path: "/ab/payments/success",
    component: () => import("/app/pages/payments/success.vue")
  },
  {
    name: "payments-success___tr",
    path: "/tr/payments/success",
    component: () => import("/app/pages/payments/success.vue")
  },
  {
    name: "payments-success___ar",
    path: "/ar/payments/success",
    component: () => import("/app/pages/payments/success.vue")
  },
  {
    name: "posterminal___ru___default",
    path: "/posterminal",
    component: () => import("/app/pages/posterminal.vue")
  },
  {
    name: "posterminal___ru",
    path: "/ru/posterminal",
    component: () => import("/app/pages/posterminal.vue")
  },
  {
    name: "posterminal___en",
    path: "/en/posterminal",
    component: () => import("/app/pages/posterminal.vue")
  },
  {
    name: "posterminal___es",
    path: "/es/posterminal",
    component: () => import("/app/pages/posterminal.vue")
  },
  {
    name: "posterminal___ab",
    path: "/ab/posterminal",
    component: () => import("/app/pages/posterminal.vue")
  },
  {
    name: "posterminal___tr",
    path: "/tr/posterminal",
    component: () => import("/app/pages/posterminal.vue")
  },
  {
    name: "posterminal___ar",
    path: "/ar/posterminal",
    component: () => import("/app/pages/posterminal.vue")
  },
  {
    name: "safeboxes___ru___default",
    path: "/safeboxes",
    component: () => import("/app/pages/safeboxes.vue")
  },
  {
    name: "safeboxes___ru",
    path: "/ru/safeboxes",
    component: () => import("/app/pages/safeboxes.vue")
  },
  {
    name: "safeboxes___en",
    path: "/en/safeboxes",
    component: () => import("/app/pages/safeboxes.vue")
  },
  {
    name: "safeboxes___es",
    path: "/es/safeboxes",
    component: () => import("/app/pages/safeboxes.vue")
  },
  {
    name: "safeboxes___ab",
    path: "/ab/safeboxes",
    component: () => import("/app/pages/safeboxes.vue")
  },
  {
    name: "safeboxes___tr",
    path: "/tr/safeboxes",
    component: () => import("/app/pages/safeboxes.vue")
  },
  {
    name: "safeboxes___ar",
    path: "/ar/safeboxes",
    component: () => import("/app/pages/safeboxes.vue")
  },
  {
    name: "vacancies___ru___default",
    path: "/vacancies",
    component: () => import("/app/pages/vacancies.vue")
  },
  {
    name: "vacancies___ru",
    path: "/ru/vacancies",
    component: () => import("/app/pages/vacancies.vue")
  },
  {
    name: "vacancies___en",
    path: "/en/vacancies",
    component: () => import("/app/pages/vacancies.vue")
  },
  {
    name: "vacancies___es",
    path: "/es/vacancies",
    component: () => import("/app/pages/vacancies.vue")
  },
  {
    name: "vacancies___ab",
    path: "/ab/vacancies",
    component: () => import("/app/pages/vacancies.vue")
  },
  {
    name: "vacancies___tr",
    path: "/tr/vacancies",
    component: () => import("/app/pages/vacancies.vue")
  },
  {
    name: "vacancies___ar",
    path: "/ar/vacancies",
    component: () => import("/app/pages/vacancies.vue")
  }
]